import { FC, useState } from 'react';
import Spacer from '@components/Spacer';
import InputField from '@components/FormFields/InputField';
import Buttons from '@components/Buttons/Buttons';
import s from '@components/CartAdditionalTermsInfo/CartAdditionalTermsInfo.module.scss';

type Props = {
  additionalFields: { label: string, key: string }[];
  onSubmit: (data: Record<string, unknown>) => void;
  onFinish?: () => void;
};

const CartAdditionalTermsInfo: FC<Props> = ({
  additionalFields,
  onFinish,
  onSubmit,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [fieldsData, setFieldsData] = useState<Record<string, unknown>>({});

  const handleSubmit = async (): Promise<void> => {
    setIsLoading(true);
    onSubmit(fieldsData);
    onFinish?.();
    setIsLoading(false);
  };

  const handleFieldChange = (key: string, val: string): void => {
    setFieldsData({
      ...fieldsData,
      [key]: val,
    });
  };

  return (
    <div className={s.container}>
      <p className='body-sm-bold'>Enter additional information:</p>
      <Spacer size={20} />
      {additionalFields.map((field) => (
        <>
          <InputField
            id={field.key}
            label={field.label}
            name={field.key}
            placeholder={`Enter ${field.label}`}
            onChange={handleFieldChange.bind(this, field.key)}
          />
          <Spacer size={16}/>
        </>
      ))}
      <Buttons
        isSecondary
        isFetching={isLoading}
        isFullWidth
        onClick={handleSubmit}
      >
        Next
      </Buttons>
    </div>
  );
};

export default CartAdditionalTermsInfo;
